import React from 'react'
import { connect } from 'react-redux'

class Employment extends React.Component {
  renderEmploymentHistories = (employments, name) => {
    return (
      <div className='card card-single'>
        <div className='card-header'>
          <div className='pull-right'>
            <a className='smaller' href='#' onClick={ () => this.props.onGoToClick('employment')}>Edit</a>
          </div>
          Employment - {name}
        </div>
        <div className='card-body'>
          { employments.map((employment, index) => {
              const jobYearsInt = (employment.jobYears == '0' || !employment.jobYears) ? 0 : employment.jobYears
              const jobMonthsInt = (employment.jobMonths == '0' || !employment.jobMonths) ? 0 : employment.jobMonths
              const industryYearsInt = (employment.industryYears == '0' || !employment.industryYears) ? 0 : employment.industryYears
              const industryMonthsInt = (employment.industryMonths == '0' || !employment.industryMonths) ? 0 : employment.industryMonths

              return (
                <div key={index}>
                  <div className='d-flex justify-content-between'>
                    <div className='block'>
                      <div className='big'>{employment.employerName}</div>
                      <div className='grey'>{employment.occupation}</div>
                    </div>
                    <div className='block text-right'>
                      <div className='big'>{employment.employmentType}</div>
                      <div className='grey'>
                        { jobYearsInt !== 0 &&
                        `${jobYearsInt}y `
                        }
                        { (jobMonthsInt !== 0 && jobYearsInt !== 0) &&
                          <span> and </span>
                        }
                        { jobMonthsInt !== 0 &&
                          `${jobMonthsInt}m`
                        }
                        { (jobMonthsInt !== 0 || jobYearsInt !== 0) &&
                          <span> in job, </span>
                        }
                        { industryYearsInt !== 0 &&
                          `${industryYearsInt}y `
                        }
                        { (industryMonthsInt !== 0 && industryYearsInt !== 0) &&
                          <span> and </span>
                        }
                        { industryMonthsInt !== 0 &&
                          `${industryMonthsInt}m`
                        }
                        { (industryMonthsInt !== 0 || industryYearsInt !== 0) &&
                          <span> in industry </span>
                        }
                      </div>
                    </div>
                  </div>
                  { employments.length > 1 &&
                    <hr/>
                  }
                </div>
              )
            })
          }
        </div>
      </div>
    )
  }


  isIncomeZero = (income) => {
    return income[0].amount === 0 && (income[0].amountPreviousYear === 0 || income[0].amountPreviousYear === null)
  }

  render() {
    const { profiles, employments, incomes } = this.props;
    const primaryIncomeIsZero = this.isIncomeZero(incomes[0])
    const secondaryIncomeIsZero = incomes[1] ? this.isIncomeZero(incomes[1]) : true

    return (
      <div>
        {!primaryIncomeIsZero && this.renderEmploymentHistories(employments.primaryEmployment, profiles[0].name)}
        {!secondaryIncomeIsZero && this.renderEmploymentHistories(employments.secondaryEmployment, profiles[1].name)}
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  incomes: state.review.incomes,
  employments: state.review.employments,
  profiles: state.review.profile,
})

export default connect(mapStateToProps, {
})(Employment)
